import { useState, useContext, useEffect } from "react"
import { gql, useQuery } from "@apollo/client"
import { Field, useFormikContext } from "formik"
import { Dropdown } from "primereact/dropdown"

import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function StaffRole({ field, block, index }) {
  const [roleList, setRoleList] = useState([])
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()

  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GET_ROLES = gql`
    query getRoles($staff_id: ID!, $organization_id: ID!) {
      roles: rolesByUid(
        staff_id: $staff_id
        organization_id: $organization_id
        group_type: 0
      ) {
        key: rol_id
        label: rol_name
      }
    }
  `
  const { loading } = useQuery(GET_ROLES, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    onCompleted: ({ roles }) => {
      setRoleList(roles)
    },
    skip: !userCtx,
  })

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta, form }) => (
            <>
              <Dropdown
                placeholder="Please select"
                id={field.field_name}
                name={formikField.name}
                value={formikField.value}
                onChange={formikField.onChange}
                disabled={isDisabled}
                options={roleList}
                onBlur={(e) => formik.handleBlur(e)}
              />
              {meta.touched && meta.error && (
                <div className={styles.errFieldMsg}>{meta.error}</div>
              )}
            </>
          )}
        </Field>
      </div>
    </div>
  )
}
